import _classCallCheck from "babel-runtime/helpers/classCallCheck";
// ***【房间模型】***
export var RoomInfo = function RoomInfo() {
  _classCallCheck(this, RoomInfo);
};
export var MemberDetail = function MemberDetail() {
  _classCallCheck(this, MemberDetail);
};
// ***【成员模型】***
export var MemberInfo = function MemberInfo() {
  _classCallCheck(this, MemberInfo);
};
// ****【家庭位置模型】***
export var FamilyLocation = function FamilyLocation() {
  _classCallCheck(this, FamilyLocation);
};
export var Room = function Room() {
  _classCallCheck(this, Room);
};
export var OwnerDetail = function OwnerDetail() {
  _classCallCheck(this, OwnerDetail);
};
export var AuthDetail = function AuthDetail() {
  _classCallCheck(this, AuthDetail);
};
export var PermissionDetail = function PermissionDetail() {
  _classCallCheck(this, PermissionDetail);
};
// ***【设备模型】***
export var DeviceInfo = function DeviceInfo() {
  _classCallCheck(this, DeviceInfo);
};
export var FamilyLocationDetail = function FamilyLocationDetail() {
  _classCallCheck(this, FamilyLocationDetail);
};
export var FamilyDetail = function FamilyDetail() {
  _classCallCheck(this, FamilyDetail);
};
export var FamilyOwnerDetail = function FamilyOwnerDetail() {
  _classCallCheck(this, FamilyOwnerDetail);
};
export var FloorInfo = function FloorInfo() {
  _classCallCheck(this, FloorInfo);
};
// ***【家庭模型】***
export var FamilyInfo = function FamilyInfo() {
  _classCallCheck(this, FamilyInfo);
};
// ***【批量处理设备信息模型】***
export var BatchProcessDevice = function BatchProcessDevice() {
  _classCallCheck(this, BatchProcessDevice);
};
// ***【批量处理设备信息集合模型】***
export var BatchProcessDeviceCollection = function BatchProcessDeviceCollection() {
  _classCallCheck(this, BatchProcessDeviceCollection);
};